export default "__VITE_ASSET__CCQLFVS1__"